// src/pages/facility/FacilityListPage.jsx

import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import FacilitiesList from "./FacilitiesList";

const ViewFacilitiesPage = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb for page title and navigation */}
      <Breadcrumb
        id="title"
        title="Facilities List"
      />

      <FacilitiesList />
    </MasterLayout>
  );
};

export default ViewFacilitiesPage;
